import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import {LandPrefixDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-landprefix-container',
  templateUrl: './landprefix-container.component.html',
  styleUrls: ['./landprefix-container.component.scss']
})
export class LandprefixContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  landPrefixs$: Observable<LandPrefixDto[]>;
  loading: boolean;
  isLoadingLandPrefix$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingLandPrefix$ = this.gatwayFacade.isLoadingGateway("LandPrefix");
    this.landPrefixs$ = this.gatwayFacade.loadGateway("LandPrefix");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLandPrefix(deletedValue: any) {
    this.gatwayFacade.remove("LandPrefix", deletedValue);
  }


// this method control both the create and update

  onSubmitLandPrefix(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.LandPrefixs;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllLandPrefix = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllLandPrefix.push(pullData[i]);
    }
  }

// check if the addAllLandPrefix array is not empty, then dispatch the data to the store
   if(addAllLandPrefix.length > 0) {
    this.gatwayFacade.add('LandPrefix', addAllLandPrefix);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('LandPrefix', allUpdates, ['id']);
  }

   }


}
